import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface OnboardingState {
  dismissed: boolean;
  dismiss: () => void;
  reset: () => void;
}

export const ONBOARDING_STEPS = [
  {
    id: 'bot',
    labelKey: 'onboarding.createBotLabel',
    descriptionKey: 'onboarding.createBotDesc',
    path: '/bots/create',
  },
  {
    id: 'start',
    labelKey: 'onboarding.startBotLabel',
    descriptionKey: 'onboarding.startBotDesc',
    path: '/bots',
  },
  {
    id: 'exchange',
    labelKey: 'onboarding.connectExchangeLabel',
    descriptionKey: 'onboarding.connectExchangeDescOptional',
    path: '/venue-connections',
  },
] as const;

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      dismissed: false,
      dismiss: () => set({ dismissed: true }),
      reset: () => set({ dismissed: false }),
    }),
    { name: 'loki-onboarding' },
  ),
);
